import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const MobileProduct = ({ handleCloseMobileNav }) => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
    handleCloseMobileNav();
  };

  const linkClass =
    "flex justify-between items-center py-1 px-2 rounded font-medium text-gray-800 no-underline hover:bg-blue-100 hover:text-main transition-colors duration-300";

  const productLinks = [
    {
      name: "Interactive Voice Response",
      path: "/interactive-voice-response",
    },
    {
      name: "Missed Call Alert Services",
      path: "/missed-call-alert-services",
    },

    {
      name: "Leads Management System",
      path: "/Leads-management-system",
    },
    { name: "Bulk SMS", path: "/bulk-sms" },
    {
      name: "Virtual Phone Number",
      path: "/virtual-phone-number",
    },
    {
      name: "Customer Relationship",
      path: "/customer-relationship",
    },
    {
      name: "Employee Tracking System",
      path: "/employee-tracking-system",
    },
  ];

  return (
    <div className="w-full bg-white rounded p-3 text-sm text-gray-800 lg:hidden">
      {productLinks.map((item) => (
        <p key={item.path}>
          <button
            onClick={() => handleClick(item.path)}
            className={`${linkClass} w-full`}
          >
            <span className=" py-[2px]">{item.name}</span>
            <FontAwesomeIcon icon={faArrowRight} className="text-[11px]" />
          </button>
        </p>
      ))}
    </div>
  );
};

export default MobileProduct;
